import { CSSProperties } from 'react';
import { StyledLabelRequiredSymbol } from './styles';

type Props = {
    style?: CSSProperties;
};
const LabelRequiredSymbol = ({ style }: Props) => {
    return <StyledLabelRequiredSymbol style={style}>*</StyledLabelRequiredSymbol>;
};

export default LabelRequiredSymbol;
